import { Grid, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InfoIcon from '@material-ui/icons/Info';
import TreeItem from '@material-ui/lab/TreeItem';
import TreeView from '@material-ui/lab/TreeView';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
    treeItemLabel: {
        alignSelf: "center"
    },
    treeItemIcon: {
        float: "right"
    },
    itemTypography: {
        margin: "8px"
    },
    clickableText: {
        color: "#4C73FF",
        cursor: "pointer"
    },
    icon: {
        fontSize: "25px !important"
    }
});

function RecursiveTreeView(props) {

    const [nodeLabels, setNodeLabels] = useState({})

    const classes = useStyles();

    useEffect(() => {
        generateNodeLabels()
    }, [])

    const gridSize = props.secondaryField != null ? 5 : 10

    /**
     * Create a map of all the node labels, using the generateRow function for labels, mpped to id of the node.
     */
    function generateNodeLabels() {
        var nodeDictionary = {}
        props.flatTree.forEach(node => {
            nodeDictionary[node.id] = generateRow(node)
        });

        setNodeLabels(nodeDictionary)
    }

    /**
     * Genereates a Label as a React element for the Tree view
     * @param {*} node The node to create the label for
     */
    function generateRow(node) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={gridSize} className={classes.treeItemLabel}>
                    <Typography display="inline" className={classes.itemTypography && classes.clickableText} onClick={event => nodeOnClick(event, node.id)}>
                        {node[props.nameField]}
                    </Typography>
                </Grid>
                {props.secondaryField != null ?
                    <Grid item xs={gridSize} className={classes.treeItemLabel}>
                        <Typography display="inline" className={classes.itemTypography && classes.clickableText} onClick={event => nodeOnClick(event, node.id)}>
                            {node[props.secondaryField]}
                        </Typography>
                    </Grid> :
                    null
                }

                <Grid item xs={2} >
                    <IconButton className={classes.treeItemIcon} onClick={event => nodeOnClick(event, node.id)}>
                        <InfoIcon />
                    </IconButton>
                </Grid>
            </Grid >
        )
    }

    /**
     * Recursive function to map out the entire Tree view from a list of nodes with children.
     * @param {*} nodes The nodes to construct TreeItems for
     * @param {*} parentId The id of the parent node
     */
    const renderTree = (nodes, parentId = null) => {
        return nodes.map((node, index) => (
            <TreeItem
                key={parentId != null ? `${node.id}-${parentId}` : node.id}
                nodeId={parentId != null ? `${node.id}-${parentId}` : node.id}
                label={nodeLabels[node.id]}
            >
                {Array.isArray(node[props.childrenField]) ? renderTree(node[props.childrenField], parentId != null ? `${node.id}-${parentId}` : node.id) : null}
            </TreeItem >
        ))
    };

    function onNodeToggle(event, expandedArray) {
        props.setExpandedArray(expandedArray)
    }

    function nodeOnClick(event, nodeId) {
        event.stopPropagation()
        props.nodeOnClick(nodeId)
    }

    return (
        <TreeView
            onNodeToggle={onNodeToggle}
            expanded={props.expandedArray}
            defaultCollapseIcon={<ExpandMoreIcon className={classes.icon} />}
            defaultExpandIcon={<ChevronRightIcon className={classes.icon} />}
        >
            {renderTree(props.data)}
        </TreeView>
    );
}

RecursiveTreeView.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    nodeOnClick: PropTypes.func.isRequired,
    nameField: PropTypes.string.isRequired,
    childrenField: PropTypes.string.isRequired,
    secondaryField: PropTypes.string,
    expandedArray: PropTypes.arrayOf(PropTypes.string).isRequired,
    setExpandedArray: PropTypes.func.isRequired
}

export default RecursiveTreeView

